module.exports = __webpack_public_path__ + "img/3.eab8ecfa.png";